import { PropsWithChildren } from 'react'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { pages } from '@app/util/links'
import { useClient } from '@based/sdk'
import {
  DropdownMenu,
  type DropdownMenuItem,
} from '@app/components/core/dropdown/DropdownMenu'

export const ProfileMenu = ({ children }: PropsWithChildren) => {
  const [language, _] = useLanguage()
  const navTranslations = i18n.languages[language].app.nav
  const dashboardTranslations = i18n.languages[language].app.dashboard.nav
  const client = useClient()

  const logOut = () => {
    void client.call('account-logout')
  }

  const items: DropdownMenuItem[] = [
    {
      type: 'link',
      label: dashboardTranslations.profile,
      to: pages.dashboardProfile,
      linkProps: {
        textStyle: { fontWeight: 400 },
      },
    },
    {
      type: 'link',
      label: dashboardTranslations.preferences,
      to: pages.dashboardPreferences,
      linkProps: {
        textStyle: { fontWeight: 400 },
      },
    },
    {
      type: 'link',
      label: dashboardTranslations.following,
      to: pages.dashboardFollowing,
      linkProps: {
        textStyle: { fontWeight: 400 },
      },
    },
    {
      type: 'link',
      label: navTranslations.dashboardHome,
      to: pages.dashboard,
      linkProps: {
        textStyle: { fontWeight: 400 },
      },
    },
    {
      type: 'button',
      label: navTranslations.logOut,
      buttonProps: {
        onClick: logOut,
        textStyle: {
          fontWeight: 400,
          textWrap: 'nowrap',
        },
      },
    },
  ]

  return (
    <DropdownMenu items={items} showOnHoverDesktop>
      {children}
    </DropdownMenu>
  )
}
